import EnumAttributeValueSuggestor from "./EnumAttributeValueSuggestor.js";
import ParentRelationshipAttributeValueSuggestor from "./ParentRelationshipAttributeValueSuggestor.js";
import ResourceEnumAttributeValueSuggestor from "./ResourceEnumAttributeValueSuggestor.js";
import StringAttributeValueSuggestor from "./StringAttributeValueSuggestor.js";
import UnitAttributeValueSuggestors from "./UnitAttributeValueSuggestors.js";
const suggestors = {
  enum: EnumAttributeValueSuggestor,
  parentRelationship: ParentRelationshipAttributeValueSuggestor,
  resourceEnum: ResourceEnumAttributeValueSuggestor,
  string: StringAttributeValueSuggestor
};
const processBlueprints = (molten, blueprints) => {
  blueprints.forEach(blueprint => {
    Object.entries(suggestors).forEach(([key, suggestor]) => {
      molten.addPlugin('AttributeValueSuggestor', {
        id: `molten.AttributeValueSuggestor.${blueprint.type}.${key}`,
        type: `${blueprint.type}.${key}`,
        suggestor
      });
      molten.addPlugin('AttributeValueSuggestor', {
        id: `molten.AttributeValueSuggestor.${blueprint.historyType}.${key}`,
        type: `${blueprint.historyType}.${key}`,
        suggestor
      });
    });
    UnitAttributeValueSuggestors.install(molten, blueprint);
  });
};
export default {
  id: 'molten.imagine.AttributeValueSuggestor',
  processBlueprints
};